import { QUERY_PROGRESS_SUCCEED } from "@recare/core/consts";
import { LegalDocumentType } from "@recare/core/types";
import { useLegalDocumentsContext } from "dsl/atoms/LegalDocumentsContext";

export default function useLegalDocuments() {
  const { legalDocuments, progress } = useLegalDocumentsContext();

  const getDocumentUrl = (type: LegalDocumentType): string => {
    const url = legalDocuments?.[type]?.url;

    if (!url && progress === QUERY_PROGRESS_SUCCEED) {
      console.error(`error fetching legal document: ${type}`);
    }

    return url ?? "";
  };

  const openDocumentUrl = (type: LegalDocumentType) =>
    window.open(getDocumentUrl(type), "_blank");

  return { legalDocuments, getDocumentUrl, openDocumentUrl };
}
